import { FunctionComponent, useCallback, useState } from "react";
import {
  Theme,
  makeStyles,
  TextField,
  StandardTextFieldProps,
  Grid,
  Typography,
  IconButton,
  InputAdornment,
} from "@material-ui/core";
import { DARK_TEXT_COLOR } from "../../../../theme/theme";
import { Visibility, VisibilityOff } from "@material-ui/icons";

const useStyles = makeStyles((theme: Theme) => ({
  textFieldContainer: {
    width: "auto",
    position: "relative",
  },
  textField: {
    width: "100%",
    "& .MuiFormLabel-root": {
      color: DARK_TEXT_COLOR,
      fontWeight: 700,
    },
  },
  errorText: {
    fontSize: 12,
    color: theme.palette.error.main,
  },
}));

interface IPresentationTextFieldProps extends StandardTextFieldProps {
  errorMessage?: string;
  isPassword?: boolean;
}

export const PresentationTextField: FunctionComponent<IPresentationTextFieldProps> = (props) => {
  const { error, errorMessage, isPassword, ...rest } = props;
  const classes = useStyles();
  const [showText, setShowText] = useState(!isPassword);

  const toggleShowText = useCallback(() => {
    setShowText(!showText);
  }, [showText, setShowText]);

  const inputProps = {
    ...props.InputProps,
    endAdornment: (
      <InputAdornment position="end">
        <IconButton onClick={toggleShowText}>{showText ? <Visibility /> : <VisibilityOff />}</IconButton>
      </InputAdornment>
    ),
  };

  return (
    <Grid container className={classes.textFieldContainer}>
      <Grid item xs={12}>
        <TextField
          className={classes.textField}
          {...rest}
          type={!showText ? "password" : props.type}
          InputProps={isPassword ? inputProps : {}}
        />
      </Grid>
      {error && <Typography className={classes.errorText}>{errorMessage}</Typography>}
    </Grid>
  );
};
